var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0032 7.20462C22.0032 13.5693 13.5615 22 7.20321 22C5.81154 22 4.51154 21.4752 3.55321 20.5171L2.71987 19.5591C1.75321 18.5927 1.75321 16.9599 2.76154 15.9519C2.78654 15.9269 4.79487 14.3857 4.79487 14.3857C5.79487 13.436 7.36987 13.436 8.36154 14.3857L9.57821 15.3604C12.2449 14.2274 14.1365 12.328 15.3532 9.57055L14.3865 8.35426C13.4282 7.36291 13.4282 5.78007 14.3865 4.78871C14.3865 4.78871 15.9282 2.78101 15.9532 2.75601C16.9615 1.748 18.5949 1.748 19.6032 2.75601L20.4782 3.51411C21.4782 4.50547 22.0032 5.80506 22.0032 7.19629V7.20462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.28a10c343429550b234a0739c51c0a33.svg";
export { ForwardRef as ReactComponent };